import { render, staticRenderFns } from "./ConfigComponent.vue?vue&type=template&id=ec974a5e&"
import script from "./ConfigComponent.vue?vue&type=script&lang=js&"
export * from "./ConfigComponent.vue?vue&type=script&lang=js&"
import style0 from "./ConfigComponent.vue?vue&type=style&index=0&id=ec974a5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports